
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldDescription from "./FieldDescription";
import FieldExpertise from "./FieldExpertise";
import FieldImage from "./FieldImage";
import FieldPrice from "./FieldPrice";
import FieldTitle from "./FieldTitle";
import FieldVideo from "./FieldVideo";
import DoctorMultiSelect from "../../../../components/DoctorMultiSelect";

export default function Form({ workshop, isDesktop }) {
	const navigate = useNavigate();
	const workshopId = workshop.id;
	const [title, setTitle] = useState(workshop.title);
	const [description, setDescription] = useState(workshop.description);
	const [price, setPrice] = useState(workshop.price);
	const [image, setImage] = useState(workshop.image);
	const [video, setVideo] = useState(workshop.intro_video);
	const [expertiseIds, setExpertiseIds] = useState([]);
	const [instructorIds, setInstructorIds] = useState(workshop.instructors || []);
	const initialDoctors = workshop.instructors_detail || [];
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	}

	const handlePriceChange = (e) => {
		setPrice(e.target.value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleVideoChange = (e) => {
		setVideo(e.target.files[0]);
	}

	const handleExpertiseChange = (expertiseIds) => {
		setExpertiseIds(expertiseIds);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.workshopEdit({
			token: LoginHelper.getToken(),
			workshop_id: workshopId,
			title: title,
			description: description,
			price: `${price ? price : ''}`,
			image_file: image,
			video_file: video,
				expertise_ids: JSON.stringify(expertiseIds),
			...(LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN ? { instructor_ids: JSON.stringify(instructorIds) } : {}),
		}).then((res) => {
			setIsLoading(false);
			navigate('/workshop_detail/' + workshopId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="ویرایش کارگاه"
			subtitle="تغییرات کارگاه را ذخیره کنید."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="ذخیره تغییرات"
		>
			<EditorFieldSection title="اطلاعات اصلی">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldDescription description={description} onChange={handleDescriptionChange} />
				<FieldPrice price={price} onChange={handlePriceChange} />
			</EditorFieldSection>
			<EditorFieldSection title="رسانه">
				<FieldImage image={image} onChange={handleImageChange} />
				<FieldVideo video={video} onChange={handleVideoChange} />
			</EditorFieldSection>
			<EditorFieldSection title="تخصص‌ها">
				<FieldExpertise workshop={workshop} onChange={handleExpertiseChange} isDesktop={isDesktop} />
			</EditorFieldSection>
			{LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN && (
				<EditorFieldSection title="مدرسین">
					<DoctorMultiSelect
						value={instructorIds}
						initialDoctors={initialDoctors}
						onChange={setInstructorIds}
					/>
				</EditorFieldSection>
			)}
		</EditorFormShell>
	);
}
